import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import echarts from '@/utils/echarts';

// 颜色十六进制 → rgba (模块级纯函数，闭包内稳定引用 echarts.graphic)
function rgba(hex, a) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}, ${a})`;
}

// ECharts 渐变色工厂
function gradient(color1, color2) {
  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
    offset: 0,
    color: color1
  }, {
    offset: 1,
    color: color2
  }]);
}

// 带面积填充的折线 series 工厂
function lineSeries(name, data, color) {
  return {
    name,
    type: 'line',
    smooth: true,
    data,
    lineStyle: {
      color,
      width: 2.5
    },
    symbol: 'circle',
    symbolSize: 6,
    itemStyle: {
      color,
      borderColor: '#fff',
      borderWidth: 2
    },
    areaStyle: {
      color: gradient(rgba(color, 0.28), rgba(color, 0.03))
    }
  };
}
export default {
  name: 'Fenglang',
  data() {
    return {
      // 图表实例
      emotionLineChart: null,
      emotionBarChart: null,
      leaderChart: null,
      // 真实数据（统一来自 cycle-analysis，25 个交易日）
      cycleData: [],
      // 周期梯队（最新在前）
      rawCycle: [],
      // 原始数据（时间升序，供图表使用）
      selectedBoardDate: '',
      currentWeek: 0,
      rangeDays: 7,
      loading: false,
      errorMsg: '',
      // 连板股票悬停 K 线浮窗
      hoverStock: null,
      popupStyle: {
        left: '0px',
        top: '0px'
      },
      klineMode: 'daily',
      // 'intraday' 分时 | 'daily' 日K
      klineLoading: false,
      klineError: '',
      klineWarn: '',
      // 分时数据与实时快照偏差过大时的提示
      priceMap: {},
      // 个股实时价（按 CODE.EX 索引）
      klineCache: {},
      // 个股日K（按原始 code 索引）
      trendCache: {},
      // 个股分时（按原始 code 索引）
      klineChart: null,
      // 浮窗内 ECharts 实例
      priceTimer: null,
      hideTimer: null,
      // 板块轮动：同类板块跨日流转虚线连接的坐标
      linkLines: []
    };
  },
  computed: {
    // 左侧列表按周分组（每 5 个交易日为一周，最新在前）
    weeks() {
      const size = 5;
      const arr = [];
      for (let i = 0; i < this.cycleData.length; i += size) {
        arr.push(this.cycleData.slice(i, i + size));
      }
      return arr;
    },
    visibleWeek() {
      return this.weeks[this.currentWeek] || [];
    },
    // 板块轮动：基于周期梯队每日 ladder，按主升题材聚合（日期倒序，最新在前）
    sectorData() {
      return this.cycleData.map(row => this.mapSectorDay(row));
    },
    // 连续上榜天数：从最旧→最新累计同名校块连续出现天数。
    // 最新日 streak = 总连续天数（含当天），≥ 2 时标记徽标。
    streakMap() {
      const rows = this.sectorData;
      if (!rows.length) return {};
      // dayNames[r][name] = 当日板块名到列号的映射
      const dayNames = rows.map(row => {
        const o = {};
        (row.hots || []).forEach((h, idx) => {
          if (h) o[h.name] = idx;
        });
        return o;
      });
      const map = {};
      // 从最旧（r=last）→ 最新（r=0）累计，以便最新日得到最大连续天数
      for (let r = rows.length - 1; r >= 0; r--) {
        (rows[r].hots || []).forEach((h, c) => {
          if (!h) return;
          let s = 1;
          if (r < rows.length - 1) {
            // 同一板块在当日（较旧）和次日（较新，computed 时已处理）都出现，则连续天数累加
            const nextCol = dayNames[r + 1][h.name];
            if (nextCol != null) s = (map[r + 1 + '-' + nextCol] || 1) + 1;
          }
          map[r + '-' + c] = s;
        });
      }
      return map;
    },
    // 当前持续热点列表：取最新一日连续 ≥2 天的板块，按连续天数降序排列
    hotStreaks() {
      const strMap = this.streakMap;
      const newest = this.sectorData[0];
      if (!newest) return [];
      const out = [];
      (newest.hots || []).forEach((h, c) => {
        if (!h) return;
        const s = strMap['0-' + c];
        if (s >= 2) out.push({
          name: h.name,
          streak: s
        });
      });
      return out.sort((a, b) => b.streak - a.streak || a.name.localeCompare(b.name));
    },
    // 选中日的连板层级（高 -> 低），数据源与左侧列表一致
    boardLevelData() {
      const row = this.cycleData.find(d => d.date === this.selectedBoardDate) || this.cycleData[0];
      if (!row || !row.ladder) return [];
      const ladder = row.ladder;
      return Object.keys(ladder).map(level => ({
        level: parseInt(level, 10),
        stocks: ladder[level] || []
      })).sort((a, b) => b.level - a.level).map(b => ({
        num: b.level,
        text: '连板',
        labelClass: b.level >= 3 ? 'level-high' : 'level-normal',
        stocks: b.stocks.map(s => ({
          name: s.name,
          code: s.code,
          tag: s.themes && s.themes[0] || ''
        }))
      }));
    },
    // 情绪卡片：最新一个交易日的情绪指标
    emotionSummary() {
      const last = this.rawCycle[this.rawCycle.length - 1];
      if (!last || !last.emotionMetrics) {
        return {
          highPromo: 0,
          p12: 0,
          brokenRatio: 0,
          limitDown: 0,
          broken: 0
        };
      }
      const e = last.emotionMetrics;
      const pr = e.promotionRates || {};
      return {
        highPromo: pr.high != null ? pr.high : 0,
        p12: pr['1to2'] != null ? pr['1to2'] : 0,
        brokenRatio: e.brokenRatio != null ? +(e.brokenRatio * 100).toFixed(1) : 0,
        limitDown: e.limitDownCount || 0,
        broken: e.brokenCount || 0
      };
    },
    // 整体情绪结论
    mood() {
      const v = this.emotionSummary.highPromo;
      if (v >= 60) return {
        text: '情绪高涨',
        cls: 'mood-up'
      };
      if (v >= 40) return {
        text: '晋级回暖',
        cls: 'mood-up'
      };
      if (v >= 25) return {
        text: '情绪中性',
        cls: 'mood-neutral'
      };
      return {
        text: '情绪低迷',
        cls: 'mood-down'
      };
    },
    latestDate() {
      const last = this.rawCycle[this.rawCycle.length - 1];
      return last ? last.date : '';
    },
    dateRangeText() {
      if (!this.rawCycle.length) return '';
      const first = this.rawCycle[0].date;
      const last = this.rawCycle[this.rawCycle.length - 1].date;
      return `数据区间 ${first} ~ ${last}`;
    },
    // 连板股票悬停浮窗：实时价派生
    hoverEx() {
      return this.hoverStock ? this.toExCode(this.hoverStock.code) : '';
    },
    kpInfo() {
      return this.hoverEx ? this.priceMap[this.hoverEx] || null : null;
    },
    kpPrice() {
      return this.kpInfo && this.kpInfo.price != null ? this.kpInfo.price.toFixed(2) : '—';
    },
    kpChange() {
      const i = this.kpInfo;
      if (!i || i.change == null || i.changePct == null) return '';
      const sign = i.change >= 0 ? '+' : '';
      return `${sign}${i.change.toFixed(2)}  ${sign}${i.changePct.toFixed(2)}%`;
    },
    priceCls() {
      const i = this.kpInfo;
      if (!i || i.change == null || i.change === 0) return 'flat';
      return i.change > 0 ? 'up' : 'down';
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.loadData();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this._ro) {
      this._ro.disconnect();
      this._ro = null;
    }
    if (this.priceTimer) {
      clearInterval(this.priceTimer);
      this.priceTimer = null;
    }
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
    if (this.emotionLineChart) {
      this.emotionLineChart.dispose();
      this.emotionLineChart = null;
    }
    if (this.emotionBarChart) {
      this.emotionBarChart.dispose();
      this.emotionBarChart = null;
    }
    if (this.leaderChart) {
      this.leaderChart.dispose();
      this.leaderChart = null;
    }
    if (this.klineChart) {
      this.klineChart.dispose();
      this.klineChart = null;
    }
  },
  methods: {
    // ===== 连板股票悬停 K 线浮窗 =====
    // 纯数字代码 → CODE.EX（沪 6*.SH / 深 0*3*.SZ / 北 8*4*.BJ）
    toExCode(raw) {
      const c = String(raw || '').replace(/[^0-9]/g, '');
      if (!c) return '';
      if (c[0] === '6') return c + '.SH';
      if (c[0] === '8' || c[0] === '4') return c + '.BJ';
      return c + '.SZ';
    },
    // 纯数字代码 → 东方财富 secid（沪 1 / 深 0）
    secidOf(raw) {
      const c = String(raw || '').replace(/[^0-9]/g, '');
      if (!c) return '';
      return (c[0] === '6' ? '1' : '0') + '.' + c;
    },
    // 按代码前缀判断涨跌停幅度（%）。主板 ±10%，创业板/科创板 ±20%，北交所 ±30；
    // 无法识别的按主板 10% 处理。新股前 5 日不设涨跌幅会在渲染时按真实数据退化。
    limitPctOf(code) {
      const c = String(code || '').replace(/[^0-9]/g, '');
      if (!c) return 10;
      if (/^(300|301)/.test(c)) return 20; // 创业板
      if (/^(688|689)/.test(c)) return 20; // 科创板
      if (/^(60|000|001|002|003)/.test(c)) return 10; // 沪市60 / 深市000-003 主板
      if (/^(8|4)/.test(c)) return 30; // 北交所 / 老三板
      return 10;
    },
    // 拉取全市场实时快照，建立 code→价 映射（一次性，定时刷新）
    async loadSnapshot() {
      try {
        const res = await fetch('/server-api/dang-quote/quotes/v2/stock-latest/snapshot');
        const data = await res.json();
        const items = data && data.data && data.data.items || [];
        const map = {};
        items.forEach(it => {
          if (it && it.code) {
            map[it.code] = {
              price: it.price,
              change: it.change,
              changePct: it.changePct,
              name: it.name,
              preClose: it.preClose
            };
          }
        });
        this.priceMap = map;
      } catch (e) {
        console.error('[Fenglang] snapshot error:', e);
      }
    },
    // 懒加载个股日K（按 code 缓存，避免重复请求）
    async loadKline(stock) {
      const code = stock.code;
      if (this.klineCache[code]) return;
      try {
        const secid = this.secidOf(code);
        const res = await fetch(`/server-api/em-kline?secid=${secid}&lmt=40`);
        const json = await res.json();
        if (json.error) throw new Error(json.error);
        if (!json.dates || !json.dates.length) throw new Error('暂无K线数据');
        this.klineCache = {
          ...this.klineCache,
          [code]: json
        };
      } catch (e) {
        this.klineCache = {
          ...this.klineCache,
          [code]: {
            error: e.message
          }
        };
      }
    },
    // 懒加载个股分时（东方财富，按 code 缓存）
    async loadTrends(stock) {
      const code = stock.code;
      if (this.trendCache[code]) return;
      try {
        const secid = this.secidOf(code);
        const res = await fetch(`/server-api/em-trends?secid=${secid}&ndays=1`);
        const json = await res.json();
        if (json.error) throw new Error(json.error);
        if (!json.times || !json.times.length) throw new Error('暂无分时数据');
        this.trendCache = {
          ...this.trendCache,
          [code]: json
        };
      } catch (e) {
        this.trendCache = {
          ...this.trendCache,
          [code]: {
            error: e.message
          }
        };
      }
    },
    // 是否处于 A 股交易时段（周一~周五 9:30-11:30 / 13:00-15:00）
    isTradingTime() {
      const now = new Date();
      const day = now.getDay();
      if (day === 0 || day === 6) return false;
      const t = now.getHours() * 60 + now.getMinutes();
      const morning = t >= 9 * 60 + 30 && t <= 11 * 60 + 30;
      const afternoon = t >= 13 * 60 && t <= 15 * 60;
      return morning || afternoon;
    },
    showStockCard(stock, ev) {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      this.hoverStock = stock;
      // 交易时段默认分时，非交易时段默认日K
      this.klineMode = this.isTradingTime() ? 'intraday' : 'daily';
      this.positionPopup(ev.currentTarget);
      this.refreshChartData(stock);
    },
    // 延迟隐藏：鼠标在卡片与浮窗之间移动时不闪烁，移出两者才消失
    scheduleHide() {
      if (this.hideTimer) clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(() => this.hideStockCard(), 200);
    },
    cancelHide() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    hideStockCard() {
      this.hoverStock = null;
      this.klineError = '';
      this.klineWarn = '';
      this.klineMode = 'daily';
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
      if (this.klineChart) {
        this.klineChart.dispose();
        this.klineChart = null;
      }
    },
    // 切换 分时 / 日K
    setKlineMode(mode) {
      if (this.klineMode === mode) return;
      this.klineMode = mode;
      if (this.hoverStock) this.refreshChartData(this.hoverStock);
    },
    // 按当前模式拉取并渲染（缓存命中则直接渲染）
    async refreshChartData(stock) {
      const code = stock.code;
      this.klineLoading = true;
      this.klineError = '';
      this.klineWarn = '';
      if (this.klineMode === 'intraday') await this.loadTrends(stock);else await this.loadKline(stock);
      // 期间已切换股票或隐藏，放弃本次渲染
      if (!this.hoverStock || this.hoverStock.code !== code) return;
      this.klineLoading = false;
      this.$nextTick(() => this.renderChart());
    },
    positionPopup(el) {
      const r = el.getBoundingClientRect();
      const W = 400,
        H = 388;
      let left = r.right + 10;
      if (left + W > window.innerWidth - 8) left = r.left - W - 10;
      if (left < 8) left = 8;
      let top = r.top + r.height / 2 - H / 2;
      if (top < 8) top = 8;
      if (top + H > window.innerHeight - 8) top = window.innerHeight - H - 8;
      this.popupStyle = {
        left: left + 'px',
        top: top + 'px'
      };
    },
    // 总渲染入口：根据 klineMode 分发
    renderChart() {
      const el = this.$refs.klineChartRef;
      if (!el || !this.hoverStock) return;
      if (this.klineChart) {
        this.klineChart.dispose();
        this.klineChart = null;
      }
      const code = this.hoverStock.code;
      if (this.klineMode === 'intraday') {
        const d = this.trendCache[code];
        if (!d || d.error || !d.times) {
          this.klineError = d && d.error || '分时数据为空';
          return;
        }
        this.klineError = '';
        this.renderIntraday(d);
      } else {
        const d = this.klineCache[code];
        if (!d || d.error || !d.dates) {
          this.klineError = d && d.error || '日K数据为空';
          return;
        }
        this.klineError = '';
        this.renderDaily(d);
      }
    },
    // 日K 蜡烛图 + 成交量（蜡烛在主图，成交量在下方独立坐标轴）
    renderDaily(d) {
      const el = this.$refs.klineChartRef;
      this.klineChart = echarts.init(el);
      const ohlc = d.dates.map((dt, i) => [d.opens[i], d.closes[i], d.lows[i], d.highs[i]]);
      // 统一主图价格轴上下限（上下各留 5% 余量）
      const allVals = d.opens.concat(d.closes, d.lows, d.highs);
      let yMin = Math.min.apply(null, allVals);
      let yMax = Math.max.apply(null, allVals);
      const ySpan = yMax - yMin || 1;
      yMin -= ySpan * 0.05;
      yMax += ySpan * 0.05;
      this.klineChart.setOption({
        backgroundColor: 'transparent',
        animation: false,
        grid: [{
          left: 10,
          right: 48,
          top: 8,
          height: '60%'
        }, {
          left: 10,
          right: 48,
          top: '74%',
          height: '18%'
        }],
        xAxis: [{
          type: 'category',
          data: d.dates,
          gridIndex: 0,
          boundaryGap: true,
          axisLabel: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: false
          }
        }, {
          type: 'category',
          data: d.dates,
          gridIndex: 1,
          boundaryGap: true,
          axisLabel: {
            color: '#94a3b8',
            fontSize: 10,
            hideOverlap: true,
            showMinLabel: true,
            showMaxLabel: true,
            formatter: v => (v || '').slice(5) // 2026-06-01 → 06-01
          },
          axisLine: {
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: false
          }
        }],
        yAxis: [
        // 主图价格轴（仅右侧显示刻度，避免左右镜像重复）
        {
          scale: true,
          gridIndex: 0,
          position: 'right',
          min: yMin,
          max: yMax,
          axisLabel: {
            color: '#94a3b8',
            fontSize: 10,
            formatter: v => v.toFixed(2)
          },
          splitLine: {
            lineStyle: {
              color: '#f1f5f9'
            }
          }
        },
        // 成交量轴（min 从 0 起，量能比例更真实）
        {
          gridIndex: 1,
          min: 0,
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        series: [{
          type: 'candlestick',
          xAxisIndex: 0,
          yAxisIndex: 0,
          data: ohlc,
          barMaxWidth: 14,
          itemStyle: {
            color: '#ef4444',
            color0: '#10b981',
            borderColor: '#ef4444',
            borderColor0: '#10b981'
          }
        }, {
          type: 'bar',
          xAxisIndex: 1,
          yAxisIndex: 1,
          data: d.vols,
          barMaxWidth: 10,
          itemStyle: {
            color: '#cbd5e1'
          }
        }]
      });
    },
    // 分时走势图：右轴价格，左轴涨跌幅%，价格线（红涨绿跌）+ 均价线
    renderIntraday(d) {
      const el = this.$refs.klineChartRef;
      this.klineChart = echarts.init(el);
      const validPrices = d.prices.filter(p => p != null && isFinite(p));
      const firstValid = validPrices.length ? validPrices[0] : 0;
      const snap = this.kpInfo;
      // 权威昨收：优先由实时快照的「当前价 + 涨跌幅」反推（与浮窗头部同源、已验证正确），
      // 因为上游 preClose 字段不可靠：dang-quote 根本不返回 preClose；腾讯 qt[4] 对该股返回的是
      // 当前价 16.94 而非昨收 15.40，会导致 0% 基准线被钉在涨停价上、整条线停在 0%。
      // 反推公式：preClose = price / (1 + changePct/100)
      let preClose = null;
      if (snap && snap.price != null && isFinite(snap.price) && snap.changePct != null && isFinite(snap.changePct) && snap.changePct > -100) {
        const r = snap.price / (1 + snap.changePct / 100);
        if (r > 0 && isFinite(r)) preClose = r;
      }
      if (!(preClose > 0)) {
        preClose = d.preClose && d.preClose > 0 ? d.preClose : firstValid;
      }
      const hasPre = preClose > 0 && isFinite(preClose);
      // 价格区间（仅用有效点，已被后端夹断的脏尖峰为 null 不参与，避免污染轴）
      const validAvgs = d.avgs.filter(a => a != null && isFinite(a));
      const vals = validPrices.concat(validAvgs);
      const dataMin = vals.length ? Math.min.apply(null, vals) : preClose;
      const dataMax = vals.length ? Math.max.apply(null, vals) : preClose;
      // 基准校验：分时末值与实时快照价差过大 → 提示数据可能异常（不静默画错线）
      const lastValid = validPrices.length ? validPrices[validPrices.length - 1] : null;
      if (snap && snap.price != null && lastValid != null && isFinite(lastValid)) {
        const dev = Math.abs(lastValid - snap.price) / (snap.price || 1);
        this.klineWarn = dev > 0.02 ? '分时走势与实时价偏差较大，数据可能延迟/异常' : '';
      } else {
        this.klineWarn = '';
      }
      const limit = this.limitPctOf(this.hoverStock.code);
      const upLimit = preClose * (1 + limit / 100);
      const downLimit = preClose * (1 - limit / 100);
      // 是否触及涨停/跌停
      const atUp = hasPre && dataMax >= upLimit * 0.995;
      const atDown = hasPre && dataMin <= downLimit * 1.005;
      let pmax, pmin;
      if (atUp || atDown) {
        // 触及涨停/跌停：铺满完整的 ±limit 范围（主板 ±10% / 双创 ±20%）。
        // 封板线顶在最上沿，昨收（0%）落在中间，与同花顺一致。
        pmax = upLimit;
        pmin = downLimit;
      } else {
        // 交易中：纵坐标随实际最高/最低灵活调整，外留 12% 余量（不铺满涨跌停）
        const span = dataMax - dataMin || preClose * 0.02;
        const pad = span * 0.12;
        pmax = dataMax + pad;
        pmin = dataMin - pad;
      }
      // 左右两轴严格同比例：右轴价格、左轴涨跌幅% 均以昨收为中心对齐（0% ↔ preClose）
      // 横轴铺满全天交易时段：完整交易时间轴，未来时段数据置 null（价格/均价线停在当下）
      const fullTimes = this.fullTradingMinutes();
      const timeIndex = {};
      fullTimes.forEach((t, i) => {
        timeIndex[t] = i;
      });
      const fullPrices = new Array(fullTimes.length).fill(null);
      const fullAvgs = new Array(fullTimes.length).fill(null);
      d.times.forEach((t, i) => {
        const label = t.length > 11 ? t.slice(11, 16) : t.slice(-5);
        const idx = timeIndex[label];
        if (idx != null) {
          fullPrices[idx] = d.prices[i];
          fullAvgs[idx] = d.avgs[i];
        }
      });
      // 深色专业行情样式：左=价格/右=百分比，三档刻度（顶=涨停红、中=昨收灰、底=跌停绿），
      // 横轴固定 09:30 / 11:30 / 15:00，价格线保持中性灰（涨跌语义交给刻度）
      const yMin = hasPre ? downLimit : pmin;
      const yMax = hasPre ? upLimit : pmax;
      const yInterval = hasPre ? (upLimit - downLimit) / 2 : undefined;
      this.klineChart.setOption({
        backgroundColor: 'transparent',
        animation: false,
        grid: {
          left: 8,
          right: 8,
          top: 8,
          bottom: 18,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: fullTimes,
          boundaryGap: false,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            fontSize: 10,
            color: '#64748b',
            interval: idx => {
              const lastIdx = fullTimes.length - 1;
              const midIdx = fullTimes.indexOf('11:30');
              return idx === 0 || idx === midIdx || idx === lastIdx;
            },
            formatter: (v, idx) => {
              const lastIdx = fullTimes.length - 1;
              const midIdx = fullTimes.indexOf('11:30');
              if (idx === 0) return '09:30';
              if (idx === midIdx) return '11:30';
              if (idx === lastIdx) return '15:00';
              return '';
            }
          }
        },
        yAxis: [{
          // 左：价格（3 档：顶=upLimit 红、中=preClose 灰、底=downLimit 绿）
          type: 'value',
          min: yMin,
          max: yMax,
          interval: yInterval,
          splitNumber: hasPre ? undefined : 5,
          position: 'left',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            fontSize: 10,
            formatter: (v, idx) => {
              if (hasPre) {
                if (idx === 2) return `{top|${v.toFixed(2)}}`;
                if (idx === 1) return `{mid|${v.toFixed(2)}}`;
                return `{bot|${v.toFixed(2)}}`;
              }
              return `{def|${v.toFixed(2)}}`;
            },
            rich: {
              top: {
                color: '#dc2626',
                fontWeight: 600,
                fontSize: 11
              },
              mid: {
                color: '#64748b',
                fontSize: 10
              },
              bot: {
                color: '#059669',
                fontWeight: 600,
                fontSize: 11
              },
              def: {
                color: '#64748b',
                fontSize: 10
              }
            }
          }
        }, {
          // 右：涨跌幅 %（同 3 档）
          type: 'value',
          min: yMin,
          max: yMax,
          interval: yInterval,
          splitNumber: hasPre ? undefined : 5,
          position: 'right',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            fontSize: 10,
            formatter: (v, idx) => {
              const pct = hasPre ? (v - preClose) / preClose * 100 : 0;
              if (hasPre) {
                if (idx === 2) return `{top|${pct >= 0 ? '+' : ''}${pct.toFixed(2)}%}`;
                if (idx === 1) return `{mid|0.00%}`;
                return `{bot|${pct.toFixed(2)}%}`;
              }
              return `{def|${pct.toFixed(2)}%}`;
            },
            rich: {
              top: {
                color: '#dc2626',
                fontWeight: 600,
                fontSize: 11
              },
              mid: {
                color: '#64748b',
                fontSize: 10
              },
              bot: {
                color: '#059669',
                fontWeight: 600,
                fontSize: 11
              },
              def: {
                color: '#64748b',
                fontSize: 10
              }
            }
          }
        }],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#cbd5e1',
              type: 'dashed'
            }
          },
          backgroundColor: 'rgba(255,255,255,0.96)',
          borderColor: '#e2e8f0',
          textStyle: {
            color: '#1e293b',
            fontSize: 11
          },
          formatter: ps => {
            const idx = ps[0].dataIndex;
            const time = fullTimes[idx];
            const price = fullPrices[idx];
            const avg = fullAvgs[idx];
            if (price == null || !isFinite(price)) return `${time}<br/>价 <span style="color:#64748b">—</span>`;
            const chg = hasPre ? price - preClose : 0;
            const pct = hasPre ? chg / preClose * 100 : 0;
            const color = hasPre ? price >= preClose ? '#dc2626' : '#059669' : '#1e293b';
            const avgTxt = avg != null && isFinite(avg) ? avg.toFixed(2) : '—';
            return `${time}<br/>价 <span style="color:${color}">${price.toFixed(2)}</span>` + ` (${chg >= 0 ? '+' : ''}${chg.toFixed(2)}  ${chg >= 0 ? '+' : ''}${pct.toFixed(2)}%)<br/>均 ${avgTxt}`;
          }
        },
        series: [{
          name: '价格',
          type: 'line',
          data: fullPrices,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            width: 1.5,
            color: '#3b82f6'
          },
          z: 3,
          markLine: hasPre ? {
            silent: true,
            symbol: 'none',
            lineStyle: {
              color: '#64748b',
              type: 'dashed',
              width: 1.2
            },
            data: [{
              yAxis: preClose
            }]
          } : undefined
        }, {
          name: '均价',
          type: 'line',
          data: fullAvgs,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            width: 1.5,
            color: '#f59e0b'
          },
          z: 2
        }]
      });
    },
    // 全天交易时段分钟标签（09:30-11:30, 13:00-15:00），用于分时图横轴铺满整日
    fullTradingMinutes() {
      const out = [];
      const push = (h0, m0, h1, m1) => {
        for (let h = h0; h <= h1; h++) {
          const mStart = h === h0 ? m0 : 0;
          const mEnd = h === h1 ? m1 : 59;
          for (let m = mStart; m <= mEnd; m++) out.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
        }
      };
      push(9, 30, 11, 30);
      push(13, 0, 15, 0);
      return out;
    },
    handleResize() {
      if (this.emotionLineChart) this.emotionLineChart.resize();
      if (this.emotionBarChart) this.emotionBarChart.resize();
      if (this.leaderChart) this.leaderChart.resize();
      this.drawLinks();
    },
    // 板块轮动：把相邻两日中同名板块的卡片用淡虚线连起来，呈现热点流转
    drawLinks() {
      const card = this.$refs.hotCard;
      const table = this.$refs.hotTable;
      if (!card || !table) return;
      const cardRect = card.getBoundingClientRect();
      const cells = table.querySelectorAll('[data-cell]');
      // 热点卡片有 border-radius，端点稍向内缩以靠近圆角
      const RADIUS = 2;
      // name -> 按日期倒序（最新在前）的单元格列表
      const map = {};
      cells.forEach(el => {
        const name = el.getAttribute('data-name');
        if (!name) return;
        const r = Number(el.getAttribute('data-r'));
        const c = Number(el.getAttribute('data-c'));
        if (!map[name]) map[name] = [];
        map[name].push({
          r,
          c,
          el
        });
      });
      const links = [];
      Object.keys(map).forEach(name => {
        const arr = map[name].sort((a, b) => a.r - b.r); // r 越小越新
        for (let i = 0; i < arr.length - 1; i++) {
          const a = arr[i]; // 较新
          const b = arr[i + 1]; // 较旧，仅相邻日连接
          if (b.r - a.r !== 1) continue;
          const ra = a.el.getBoundingClientRect();
          const rb = b.el.getBoundingClientRect();
          // 从卡片边角附近牵线：端点向内偏移 RADIUS 贴合圆角
          const dx = b.c - a.c;
          let x1, y1, x2, y2;
          if (dx > 0) {
            // 次日板块右移：a 右下角 -> b 左上角
            x1 = ra.right - RADIUS;
            y1 = ra.bottom - RADIUS;
            x2 = rb.left + RADIUS;
            y2 = rb.top + RADIUS;
          } else if (dx < 0) {
            // 次日板块左移：a 左下角 -> b 右上角
            x1 = ra.left + RADIUS;
            y1 = ra.bottom - RADIUS;
            x2 = rb.right - RADIUS;
            y2 = rb.top + RADIUS;
          } else {
            // 同列：右侧边角相连
            x1 = ra.right - RADIUS;
            y1 = ra.bottom - RADIUS;
            x2 = rb.right - RADIUS;
            y2 = rb.top + RADIUS;
          }
          links.push({
            x1: x1 - cardRect.left,
            y1: y1 - cardRect.top,
            x2: x2 - cardRect.left,
            y2: y2 - cardRect.top
          });
        }
      });
      this.linkLines = links;
    },
    formatDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
    getWeekday(dateStr) {
      const d = new Date(String(dateStr).replace(/-/g, '/'));
      const w = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      return w[d.getDay()] || '';
    },
    // 点击左侧交易日，联动右侧连板身位
    selectDate(row) {
      this.selectedBoardDate = row.date;
    },
    // 周翻页：上一周（更旧，currentWeek 增大）→ 下一周（更新，currentWeek 减小）
    prevWeek() {
      if (this.currentWeek < this.weeks.length - 1) this.currentWeek++;
    },
    nextWeek() {
      if (this.currentWeek > 0) this.currentWeek--;
    },
    // 某日某板位的连板家数
    boardCount(row, level) {
      const arr = row.ladder && row.ladder[String(level)];
      return arr ? arr.length : 0;
    },
    async loadData() {
      this.loading = true;
      this.errorMsg = '';
      try {
        const end = new Date();
        const start = new Date();
        start.setDate(end.getDate() - 25);
        const startDate = this.formatDate(start);
        const endDate = this.formatDate(end);
        // 并行请求 cycle-analysis + snapshot，减少首屏等待
        const [cycleRes, snapRes] = await Promise.all([fetch(`/server-api/quicktiny/ladder/cycle-analysis?startDate=${startDate}&endDate=${endDate}`).then(r => r.json()), fetch('/server-api/dang-quote/quotes/v2/stock-latest/snapshot').then(r => r.json()).catch(() => null)]);
        const cycleArr = cycleRes && cycleRes.data ? cycleRes.data : [];
        // 原始数据按时间升序保存（图表用），表格展示时倒序为最新在前
        this.rawCycle = cycleArr;
        this.cycleData = cycleArr.slice().reverse().map(d => this.mapCycleDay(d));
        this.currentWeek = 0;
        this.selectedBoardDate = this.cycleData.length ? this.cycleData[0].date : '';
        // 处理 snapshot 结果
        if (snapRes && snapRes.data && snapRes.data.items) {
          const map = {};
          snapRes.data.items.forEach(it => {
            if (it && it.code) {
              map[it.code] = {
                price: it.price,
                change: it.change,
                changePct: it.changePct,
                name: it.name,
                preClose: it.preClose
              };
            }
          });
          this.priceMap = map;
        }
        this.$nextTick(() => {
          this.renderCharts();
          this.drawLinks();
          // 布局完全稳定后再补一次，避免字体/图表撑开导致的偏差
          setTimeout(() => this.drawLinks(), 80);
          if (this.priceTimer) clearInterval(this.priceTimer);
          this.priceTimer = setInterval(this.loadSnapshot, 90000);
        });
      } catch (e) {
        this.errorMsg = '数据加载失败，请稍后重试';
        console.error('[Fenglang] loadData error:', e);
      } finally {
        this.loading = false;
      }
    },
    mapCycleDay(day) {
      const ms = day.marketSentiment || {};
      const total = (ms.rise || 0) + (ms.fall || 0);
      const upPercent = total ? Math.round(ms.rise / total * 100) : 0;
      const downPercent = total ? 100 - upPercent : 0;
      const ladder = day.ladder || {};
      return {
        date: day.date,
        week: day.weekday,
        indexRate: parseFloat(day.index && day.index.value || '0') || 0,
        amount: parseInt(day.turnover && day.turnover.value || '0', 10) || 0,
        upCount: ms.rise || 0,
        downCount: ms.fall || 0,
        upPercent,
        downPercent,
        ladder,
        emotionMetrics: day.emotionMetrics || {}
      };
    },
    // 板块轮动：按主升题材聚合当天涨停股（题材来自 ladder 中每只股票的 themes）
    mapSectorDay(row) {
      const themeMap = {};
      const ladder = row.ladder || {};
      Object.keys(ladder).forEach(level => {
        const lv = parseInt(level, 10);
        (ladder[level] || []).forEach(s => {
          const t = s.themes && s.themes[0] || '其他';
          if (!themeMap[t]) themeMap[t] = {
            name: t,
            maxBoard: lv,
            stocks: []
          };
          if (lv > themeMap[t].maxBoard) themeMap[t].maxBoard = lv;
          themeMap[t].stocks.push({
            name: s.name,
            board: lv
          });
        });
      });
      const hots = Object.keys(themeMap).map(k => ({
        name: themeMap[k].name,
        stockCount: themeMap[k].stocks.length,
        maxBoard: themeMap[k].maxBoard,
        stocks: themeMap[k].stocks.slice(0, 3)
      })).sort((a, b) => b.stockCount - a.stockCount).slice(0, 5);
      return {
        date: row.date,
        week: row.week,
        hots
      };
    },
    // 健壮初始化：等待容器具备尺寸后再绘制，避免空白；并挂接尺寸监听自适应
    renderCharts() {
      const inits = [['emotionLineChartRef', () => this.initEmotionLineChart()], ['emotionBarChartRef', () => this.initEmotionBarChart()], ['leaderChartRef', () => this.initLeaderChart()]];
      const runOne = (ref, fn, tries) => {
        const el = this.$refs[ref];
        if (el && el.clientWidth > 0 && el.clientHeight > 0) {
          fn();
        } else if (tries > 0) {
          setTimeout(() => runOne(ref, fn, tries - 1), 60);
        }
      };
      inits.forEach(([ref, fn]) => runOne(ref, fn, 10));
      // 容器尺寸变化时重绘
      if (this._ro) this._ro.disconnect();
      this._ro = new ResizeObserver(() => this.handleResize());
      if (this.$refs.trendGridRef) this._ro.observe(this.$refs.trendGridRef);
    },
    // 保留内部缩放（鼠标滚轮），让时间范围按钮可通过 dispatchAction 生效
    zoomConfig(start, end) {
      return [{
        type: 'inside',
        start,
        end
      }];
    },
    // 默认（近7日）起始位置，按数据总量折算百分比
    defaultStart() {
      const n = this.rawCycle.length || 25;
      return Math.max(0, 100 - 7 / n * 100);
    },
    // 通过 dispatchAction 统一变更三张图的时间范围（独立于滑块拖拽，稳定可靠）
    zoomAll(days) {
      this.rangeDays = days;
      const n = this.rawCycle.length || 25;
      const start = days > 0 ? Math.max(0, 100 - days / n * 100) : 0;
      const end = 100;
      [this.emotionLineChart, this.emotionBarChart, this.leaderChart].forEach(c => {
        if (c) c.dispatchAction({
          type: 'dataZoom',
          start,
          end
        });
      });
    },
    // 初始化图表容器：获取 dom → dispose 旧实例 → 创建新实例
    initChart(ref, key) {
      const dom = this.$refs[ref];
      if (!dom) return null;
      if (this[key]) this[key].dispose();
      const chart = echarts.init(dom);
      this[key] = chart;
      return chart;
    },
    // 共享 tooltip 配置（axis / item 两种 trigger）
    chartTooltip(trigger = 'axis') {
      return {
        trigger,
        ...(trigger === 'item' ? {} : {
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: 'rgba(30,41,59,0.8)',
              color: '#fff',
              padding: [8, 12],
              borderRadius: 4
            }
          }
        }),
        padding: 10,
        borderRadius: 4,
        backgroundColor: 'rgba(255,255,255,0.96)',
        borderColor: '#e2e8f0',
        borderWidth: 1,
        textStyle: {
          color: '#1e293b'
        }
      };
    },
    // 连板晋级率趋势图
    initEmotionLineChart() {
      if (!this.initChart('emotionLineChartRef', 'emotionLineChart')) return;
      const dates = this.rawCycle.map(d => d.date.slice(5));
      const promo = key => this.rawCycle.map(d => {
        const pr = d.emotionMetrics && d.emotionMetrics.promotionRates;
        return pr && pr[key] != null ? pr[key] : 0;
      });
      this.emotionLineChart.setOption({
        backgroundColor: 'transparent',
        tooltip: this.chartTooltip(),
        legend: {
          data: ['1进2', '2进3', '3进4', '高位晋级'],
          bottom: 0,
          type: 'scroll',
          textStyle: {
            color: '#64748b',
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '12%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#64748b',
            fontSize: 12,
            hideOverlap: true
          }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            formatter: '{value}%',
            color: '#64748b',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: '#f1f5f9',
              type: 'dashed'
            }
          }
        },
        dataZoom: this.zoomConfig(this.defaultStart(), 100),
        series: [lineSeries('1进2', promo('1to2'), '#F87171'), lineSeries('2进3', promo('2to3'), '#EF4444'), lineSeries('3进4', promo('3to4'), '#DC2626'), lineSeries('高位晋级', promo('high'), '#3B82F6')]
      });
    },
    // 市场亏钱效应监控图
    initEmotionBarChart() {
      if (!this.initChart('emotionBarChartRef', 'emotionBarChart')) return;
      const dates = this.rawCycle.map(d => d.date.slice(5));
      const limitDown = this.rawCycle.map(d => d.emotionMetrics && d.emotionMetrics.limitDownCount || 0);
      const broken = this.rawCycle.map(d => d.emotionMetrics && d.emotionMetrics.brokenCount || 0);
      const brokenRatio = this.rawCycle.map(d => {
        const r = d.emotionMetrics && d.emotionMetrics.brokenRatio;
        return r != null ? +(r * 100).toFixed(1) : 0;
      });
      this.emotionBarChart.setOption({
        backgroundColor: 'transparent',
        tooltip: this.chartTooltip(),
        legend: {
          data: ['跌停家数', '炸板家数', '炸板率'],
          bottom: 0,
          type: 'scroll',
          textStyle: {
            color: '#64748b',
            fontSize: 12
          }
        },
        grid: {
          left: '8%',
          right: '15%',
          bottom: '12%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#64748b',
            fontSize: 12,
            hideOverlap: true
          }
        },
        yAxis: [{
          type: 'value',
          name: '家数',
          nameLocation: 'end',
          nameGap: 8,
          nameTextStyle: {
            color: '#64748b',
            fontSize: 12,
            align: 'left'
          },
          position: 'left',
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#64748b',
            fontSize: 12
          },
          splitLine: {
            lineStyle: {
              color: '#f1f5f9',
              type: 'dashed'
            }
          }
        }, {
          type: 'value',
          name: '炸板率',
          nameLocation: 'end',
          nameGap: 8,
          nameTextStyle: {
            color: '#64748b',
            fontSize: 12,
            align: 'right'
          },
          position: 'right',
          max: 100,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            formatter: '{value}%',
            color: '#64748b',
            fontSize: 12
          },
          splitLine: {
            show: false
          }
        }],
        dataZoom: this.zoomConfig(this.defaultStart(), 100),
        series: [{
          name: '跌停家数',
          type: 'bar',
          yAxisIndex: 0,
          data: limitDown,
          barWidth: '32%',
          barGap: '35%',
          barCategoryGap: '55%',
          itemStyle: {
            color: gradient('#10B981', '#6EE7B7'),
            borderRadius: [4, 4, 0, 0]
          }
        }, {
          name: '炸板家数',
          type: 'bar',
          yAxisIndex: 0,
          data: broken,
          barWidth: '32%',
          itemStyle: {
            color: gradient('#F43F5E', '#FECDD3'),
            borderRadius: [4, 4, 0, 0]
          }
        }, {
          name: '炸板率',
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          data: brokenRatio,
          lineStyle: {
            color: '#F59E0B',
            width: 2.5
          },
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            color: '#F59E0B',
            borderColor: '#fff',
            borderWidth: 2
          }
        }]
      });
    },
    // 龙头股高度轨迹图
    initLeaderChart() {
      if (!this.initChart('leaderChartRef', 'leaderChart')) return;
      const sorted = this.rawCycle.slice().sort((a, b) => a.date < b.date ? -1 : 1);
      const dates = sorted.map(d => d.date);
      const maxHeight = new Map();
      sorted.forEach(d => {
        Object.keys(d.ladder || {}).forEach(k => {
          const h = parseInt(k, 10);
          (d.ladder[k] || []).forEach(s => {
            if (!maxHeight.has(s.name) || maxHeight.get(s.name) < h) maxHeight.set(s.name, h);
          });
        });
      });
      const leaders = [...maxHeight.entries()].sort((a, b) => b[1] - a[1]).slice(0, 7).map(e => e[0]);
      const colors = ['#DC2626', '#EF4444', '#F87171', '#FB7185', '#F43F5E', '#EC4899', '#F59E0B'];
      const series = leaders.map((name, idx) => ({
        name,
        type: 'line',
        smooth: false,
        data: dates.map(date => {
          const day = sorted.find(d => d.date === date);
          let h = null;
          Object.keys(day.ladder || {}).forEach(k => {
            if ((day.ladder[k] || []).some(s => s.name === name)) h = parseInt(k, 10);
          });
          return h;
        }),
        lineStyle: {
          color: colors[idx % colors.length],
          width: 2.5
        },
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: {
          color: '#ffffff',
          borderColor: colors[idx % colors.length],
          borderWidth: 2
        }
      }));
      this.leaderChart.setOption({
        backgroundColor: 'transparent',
        tooltip: this.chartTooltip('item'),
        legend: {
          data: leaders,
          bottom: 0,
          type: 'scroll',
          textStyle: {
            color: '#64748b',
            fontSize: 10
          }
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '12%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisLabel: {
            color: '#64748b',
            fontSize: 11,
            hideOverlap: true
          }
        },
        yAxis: {
          type: 'value',
          name: '连板高度',
          min: 0,
          max: 8,
          interval: 1,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#e2e8f0'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#64748b',
            fontSize: 12
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#f1f5f9',
              type: 'solid'
            }
          }
        },
        dataZoom: this.zoomConfig(this.defaultStart(), 100),
        series
      });
    }
  }
};